import { render, staticRenderFns } from "./RememberCheckboxComponent.vue?vue&type=template&id=4cfc736a&scoped=true"
import script from "./RememberCheckboxComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./RememberCheckboxComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./RememberCheckboxComponent.vue?vue&type=style&index=0&id=4cfc736a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfc736a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cfc736a')) {
      api.createRecord('4cfc736a', component.options)
    } else {
      api.reload('4cfc736a', component.options)
    }
    module.hot.accept("./RememberCheckboxComponent.vue?vue&type=template&id=4cfc736a&scoped=true", function () {
      api.rerender('4cfc736a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/loginForm/RememberCheckboxComponent.vue"
export default component.exports